import { blogPosts } from "./blogPosts";

export const projects = [
  {
    title: "Bishop on Chessboard",
    description:
      "Visualise valid moves for a bishop on an interactive chessboard and explore board logic.",
    link: "https://codesandbox.io/p/sandbox/bishop-on-chessboard-jdnrk6",
  },
  {
    title: "Star Rating",
    description:
      "A reusable star rating component with hover previews and keyboard support built in React.",
    link: "https://codesandbox.io/p/sandbox/exciting-hertz-q3qevm",
  },
];

export const blogs = blogPosts.map(({ slug, title, description }) => ({
  title,
  description,
  link: `/blogs/${slug}`,
}));
